import { render, staticRenderFns } from "./PostulatedProjectForm.vue?vue&type=template&id=4753e3e5&scoped=true"
import script from "./PostulatedProjectForm.vue?vue&type=script&lang=js"
export * from "./PostulatedProjectForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4753e3e5",
  null
  
)

export default component.exports